<div id="managePopUp">
  <div class="modal-header">
    <div class="modal-title" *ngIf="isSingleLine; else multipleLineHeader">{{authoringContentData?.manageLineRestore?.singleLineHeader}}</div>
    <ng-template #multipleLineHeader>
      <div class="modal-title">{{authoringContentData?.manageLineRestore?.multiLineHeader}}</div>
    </ng-template>
    <button type="button" class="close" aria-label="Close" (click)="closePopupTagging()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div *ngIf="isSingleLine; else multipleLine">
      <div *ngFor="let line of restoreLines">
        <div class="modal-subtitle">
          <span id="old-number">{{line?.msisdn}}</span>
        </div>
        <p>{{line.restoreInfoTxt}}</p>
        <p *ngIf="isAmOktaEnabled">{{authoringContentData?.manageLineRestore?.restoreMsgTxt}}</p>

        <div class="row">
          <div class="col-12 col-sm-12 col-lg-6 col-md-6 no-padding">
            <div class="label_box">
              <div class="date_label">
                <div class="datepic_box">
                  <input [disabled] = "btnDisabled" type="text" tabindex="0" role="button" readonly class="datepicker" name="dp" [(ngModel)]="restoreDate" ngbDatepicker #d1="ngbDatepicker"
                  (keydown)="d1.toggle()" (click)="d1.toggle()" [minDate]="minimumDate" [maxDate] = "maximumDate" (dateSelect)="oneLineDateSelected(restoreLines[0])" />
                  <label id="temporary-start_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': restoreDate}">{{authoringContentData?.manageLineRestore?.restoreDateTxt}}</label>
                  <button class="calIconButton" (click)="d1.toggle()" [disabled] = "btnDisabled"><span class="box_icon date_iocn"></span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="line.showErrorMessage">
          <div class = "col-12 col-sm-12 col-lg-12 col-md-12 errorInline">
              {{line.showErrorMessage}}
          </div>
        </div>
      </div>
    </div>
    <!-- start accordian-->
    <ng-template #multipleLine>
      <div>
        <p>{{authoringContentData?.manageLineRestore?.multipleLineHeaderTxt}}</p>

        <div class="row">
          <div class="col-12 col-sm-6 col-md-6">
            <div class="label_box">
              <div class="date_label">
                <div class="datepic_box">
                  <input [disabled] = "btnDisabled" type="text" tabindex="0" role="button" readonly class="datepicker" name="dp" [(ngModel)]="restoreDateGlobal" ngbDatepicker #d1="ngbDatepicker"
                  (keydown)="d1.toggle()" (click)="d1.toggle()"  (dateSelect)="applyToAllCalenders()" [minDate]="minimumDate"/>
                  <label id="temporary-start_date_label_global start-date-position" [ngClass]="{'floating-label-hasvalue-date': restoreDateGlobal}">{{authoringContentData?.manageLineRestore?.restoreDateTxt}}</label>
                  <button class="calIconButton" (click)="d1.toggle()" [disabled] = "btnDisabled"><span class="box_icon date_iocn"></span></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6">
            <div class="margin-top-checkBox">
              <mat-checkbox [disabled]="!restoreDateGlobal" (change)="applyToAllCheckbox($event)"
                            [(ngModel)]="restoreDateGlobalCheckbox" [ngClass]="{'checkBoxDisabled': !restoreDateGlobal}"></mat-checkbox>
              <span class="text-color margin-left-checkBox">{{authoringContentData?.manageLineRestore?.applyToAllTxt}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 col-md-6 tmo-numberOfLines">
            <span class="line-selected">
              {{restoreLines?.length}} {{authoringContentData?.manageLineRestore?.lineSelectedTxt}}
            </span>
          </div>
        </div>

        <br>

        <mat-accordion *ngFor="let line of restoreLines;let i = index">
          <mat-expansion-panel [expanded]="line.expendFlagValue" (closed)="expansionPanelClosed(line)" (opened)="expansionPanelOpened(line)">
            <mat-expansion-panel-header class="specific-class" (click)="manageLineService.setStep(i)">
              <mat-panel-title class="accordion-txt">
                <span class="succes_validator" *ngIf="line?.succesValidator"></span>
                <span class="suspend_error_complete" *ngIf="line.errorValidator"></span>
                {{line?.msisdn}}

                <div id="displaytemporary_2" class="displaytemporary pl-5 col-md-7 col-sm-7 col-xs-7" *ngIf="line.msgShowOnPanel && line.dateForamted">
                  <div class="row">
                    <div id="displaydatetemporary_2" class="displaydatetemporary pl-6 col-md-6 col-sm-5 col-xs-6">{{line.dateForamted | date}}</div>
                  </div>
                  <div class="row">
                    <div class="reasontemporarytxt pl-3 col-md-12 col-sm-12 col-xs-12">{{authoringContentData?.manageLineRestore?.restoreCapsTxt}}</div>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="small-normal-black">

              <p>{{line.restoreInfoTxt}}</p>
              <p *ngIf="isAmOktaEnabled">{{authoringContentData?.manageLineRestore?.restoreMsgTxt}}</p>
              <p *ngIf="line.maxDateEligibleMessage">{{authoringContentData?.manageLineRestore?.maxDateEligibleMessage}}</p>
              <div class="row col-lg-6 col-sm-6 col-md-6 " id="temporary-end_date_div">
                <div class="label_box">
                  <div class="date_label">
                    <div class="datepic_box">
                      <input [disabled] = "btnDisabled" type="text" tabindex="0" role="button" readonly class="datepicker" name="dp" [(ngModel)]="line.multiRestoreDate" ngbDatepicker
                        #d="ngbDatepicker" (keydown)="d.toggle()" (click)="d.toggle()" (dateSelect)="multiplRestoreDateSelecttion(line)"
                        [minDate]="minimumDate" [maxDate] = "line.maximumDate" [ngClass]="{'storeDateClaenderDisable': line.startDate}" />
                      <label id="temporary-end_date_label start-date-position" [ngClass]="{'floating-label-hasvalue-date': line.multiRestoreDate}">{{authoringContentData?.manageLineRestore?.restoreDateTxt}}</label>
                      <button class="calIconButton" (click)="d.toggle()" [disabled] = "btnDisabled"><span class="box_icon date_iocn" [ngClass]="{'storeDateClaenderDisable': !line.multiRestoreDate}"></span></button>
                    </div>
                  </div>
                </div>
                <div class="errorInline" *ngIf="line.showErrorMessage">
                  {{line.showErrorMessage}}
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-4 mt-3">
                  <button type="button" class="col-12 primary_btn" (click)="nextStep(line)" [disabled]="!line.multiRestoreDate">{{authoringContentData?.manageLineRestore?.nextTxt}}</button>
                </div>
                <div class="col-12 col-md-4 mt-3">
                  <a href="javascript:void(0)" (click)="removeNumber(line)" class="small-pink remove-number-padding">{{authoringContentData?.manageLineRestore?.removeNumberTxt}}</a>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <hr id="tmo-suspendMulti-horizontalLine_1" class="suspend-horizontalline">
        </mat-accordion>
      </div>
    </ng-template>
    <!-- end accordian-->
  </div>

  <div class="pb-5">
    <div class="modal-footer">

      <div class="row col-12 p-0">
        <div class="col-12 col-sm-12 col-md-4 mt-3 pl-0">
          <button type="button" class="col-12 primary_btn" (click)="submitRestoreLine()" [disabled]="!selectsubmitCheckBox || isSubmitReadOnly">{{authoringContentData?.manageLineRestore?.submitChangeTxt}}</button>
        </div>
        <div class="col-12 col-sm-12 col-md-8 mt-4 pl-0 termCondition">
          <div [ngClass]="{'checkBoxDisabled': checkboxDisable}" class="chk-bx-custom">
            <mat-checkbox [(ngModel)]="selectsubmitCheckBox" [disabled]="checkboxDisable"></mat-checkbox>
          </div>
          <div class="acceptanceText">
            <span class="text-color">{{authoringContentData?.manageLineRestore?.aggreTemsConditionTxt}}</span>
          </div>
        </div>
      </div>

    </div>
    <br>
    <div class="modal-footer pb-0 pt-0" *ngIf="selectsubmitCheckBox">
      <div class="row col-12 pl-0 ">
        <div class="col-12">
          <div class="service-note ">
            <p class="text-color">{{authoringContentData?.manageLineRestore?.infoMstTxt}}</p>
            <p class="text-color" *ngIf="isSingleLine && singleLineReasonCode === 'SSQ'">{{authoringContentData?.suspend?.seasonalSuspendText}}</p>
            <p class="text-color" *ngIf="isSingleLine && (singleLineReasonCode === 'ELST' || singleLineReasonCode === 'SSQ')">
              {{authoringContentData?.suspend?.ssqOrElstText}}
            </p>
            <p class="text-color" *ngIf="!(isSingleLine && (singleLineReasonCode === 'ELST' || singleLineReasonCode === 'SSQ'))">{{authoringContentData?.manageLineRestore?.inforMsgTwoTxt}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
